export default "__VITE_ASSET__f0fac24b__"